<style lang="scss">
$mainColor: #00698d;
.admin-header{
  position:relative;
  height:80px;
  top:0;
  left:0;
  width:100%;
  padding:0 50px;
  background:#00364a;
  z-index:100;
  .urban-nav{
    .logo{
      position:absolute;
      padding-left:200px;
      height:80px;
      top:0;
      background:url('../img/admin/white-logo.png') no-repeat left center;
      line-height:80px;
      font-size:24px;
      font-weight:bold;
      color:#fff;
      width:auto;
      margin-top:auto;
    }
    .password-btn{
      width:auto;
      height:auto;
      margin-top:auto;
      position:absolute;
      top:0;
      right:120px;
      font-size:14px;
      color:#fff;
      line-height:80px;
      background:none;
    }
    .logout-btn{
      width:auto;
      height:auto;
      margin-top:auto;
      position:absolute;
      top:0;
      right:50px;
      font-size:14px;
      color:#ff4d73;
      font-weight: bold;
      line-height:80px;
      background:none;
    }
  }
}
#modify-password{
  .form-label{
    font-size:16px;
  }
  .form-input{
    width:100%;
    padding:5px 10px;
    font-size:18px;
    border:1px solid #bfbfbf;
  }
  .rg-btn-area{
    .input-area{
      text-align:right;
      margin-top:50px;
    }
    .btn-primary{
      padding:10px;
      border-radius: 5px;
    }
  }
}
</style>
<template>
<header class="admin-header">
  <nav class="urban-nav">
       <router-link to="/"><h1 class="logo">{{tit}}</h1></router-link>
      <button type="button" class="password-btn" @click="passwordChange()">비밀번호 변경</button>
      <button type="button" class="logout-btn" @click="clickLogout()">로그아웃</button>
    </nav>
    <b-modal
      id="modify-password"
      class="item-modal pwd-modal"
      size="lg"
      title="비밀번호 변경"
      hide-footer
      >
      <form @submit.prevent="submit">
        <b-row class="modal-top-row">
          <b-col class="my-1 text-left " sm="12">
            <b-row class="modal-top-row">
              <b-col sm="12" class="half text-left">
                <div class="form-group" :class="{ 'form-group-error': $v.currentPwd.$error }">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-pwd">현재 비밀번호</label>
                    </div>
                    <div class="desc search">
                      <input v-model="currentPwd" id="user-pwd" type="password" class="form-input">
                      <p class="error" v-if="!$v.currentPwd.required">현재 비밀번호를 입력해주세요.</p>
                      <p class="error" v-if="!$v.currentPwd.validaPwd">비밀번호는 최소 8글자 이상 그리고 하나 이상의 특수문자를 포함해야합니다.</p>
                    </div>
                  </div>
                </div>
                <div class="form-group" :class="{ 'form-group-error': $v.password.$error }">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-password">변경하실 비밀번호</label>
                    </div>
                    <div class="desc search">
                      <input v-model="password" id="user-password" type="password" class="form-input">
                      <div class="error" v-if="!$v.password.required">변경하실 비밀번호를 입력해주세요.</div>
                    </div>
                  </div>
                </div>
                <div class="form-group" :class="{ 'form-group-error': $v.repeatPassword.$error }">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-repeatPassword">비밀번호 확인</label>
                    </div>
                    <div class="desc search">
                      <input v-model="repeatPassword" id="user-repeatPassword" type="password" class="form-input">
                      <div class="error" v-if="!$v.repeatPassword.required">변경하실 비밀번호를 입력해주세요.</div>
                      <div class="error" v-if="!$v.repeatPassword.sameAsPassword">비밀번호가 일치하지 않습니다.</div>
                      <div class="error" v-if="!$v.repeatPassword.validaPwd">비밀번호는 최소 8글자 이상 그리고 하나 이상의 특수문자를 포함해야합니다.</div>
                    </div>
                  </div>
                </div>
                <div class="form-group rg-btn-area" style="margin:0;">
                  <div class="input-area" style="text-algin:right;">
                    <button class="btn-primary" type="submit">비밀번호 변경</button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </header>
</template>
<script>
import { mapGetters } from 'vuex'
import { required, sameAs, helpers } from 'vuelidate/lib/validators'
const validaPwd = helpers.regex('validaPwd', /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/)
export default {
  name: 'AdminHeader',
  props: ['tit'],
  data () {
    return {
      currentPwd: '',
      password: '',
      repeatPassword: ''
    }
  },
  validations: {
    currentPwd: {
      required,
      validaPwd
    },
    password: {
      required
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs('password'),
      validaPwd
    }
  },
  methods: {
    clickLogout () {
      sessionStorage.clear()
      alert('로그아웃 되었습니다.')
      this.$router.push('AdminLogin')
    },
    passwordChange () {
      this.$root.$emit('bv::show::modal', 'modify-password')
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        alert('입력정보를 확인해주세요.')
      } else {
        const param = {
          'prevPw': this.currentPwd,
          'nextPw': this.repeatPassword
        }
        this.$store.dispatch('apiUserPwTran', param).then(() => {
          // console.log('this.tranPwRtn = ' + this.tranPwRtn.result)
          if (this.tranPwRtn.result === 'success') {
            this.$nextTick(() => {
              alert('변경이 완료 되었습니다.')
              this.$bvModal.hide('modify-password')
            })
          } else if (this.tranPwRtn.result === 'pwError') {
            alert('현재 비밀번호를 잘못 입력하였습니다. 다시 입력해 주세요!')
          } else {
            alert('변경에 실패하였습니다.')
          }
        })
      }
    }
  },
  mounted () {
  },
  computed: {
    // adminuser.js에 비밀번호 변경 로직 추가
    ...mapGetters({
      tranPwRtn: 'getAdminUserPwRtn'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminHeader.vue